import React, { Component } from "react";
import { I8N, StringUtil } from "@eres/core";
import Strings from "@my-dld/assets/strings";
import TextInputField from "../Form/TextInputField";
import { JQModal } from "../Popup/Utils";
import Popup from "../Popup/Popup";
import { Party, Role } from "@eres/rtregistrationapi/entities";

interface Props {
	role: Role;
	editIndex?: number;
	onDismiss?: ( role?: Role ) => void;
}

interface State {
	role: Role;
	editIndex?: number;
	EnglishName?: string;
	ArabicName?: string;
	error: { [ k: string ]: string };
}

class AddPartyOnlyNamePopup extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			...stateFromProps( props )
		} as State;
	}

	render() {
		const { role, error } = this.state;
		const roleName = I8N.isRTL() ? role.RoleNameAr : role.RoleName;
		return <Popup
			id={ "AddPartyOnlyNamePopup" }
			modalMainContainer={ "modal fade" }
			modalSubContainer={ "modal-dialog modal-dialog-centered modal-lg" }
			clickOutsideToDismiss={ false }
			showCloseButton={ true }
			closeClass={ "close modal-close-svg-icon" }
			closeSpanClass={ "close-svg-icon" }
			modalBodyContainer={ "modal-body" }
			showIcon={ false }
			title={ Strings.party_information + " - " + roleName }
			onDismiss={ () => this.dismissModel() }>
			<div className="row">
				<div className="col-md-12">
					<div className="mandatory-field-info"><small>{ Strings.mandatory_fields_note }</small>
					</div>
				</div>
				<div className="col-md-12 font-weight-bold mb-3">{ Strings.personal_information }</div>
				<div className="col-md-6">
					<TextInputField
						id={ "EnglishName" }
						holder={ this }
						required={ true }
						label={ Strings.name_english }
						type={ "english" }
						error={ error.EnglishName }
						disabled={ role.RoleOrder === 1 }
						containerClassName={ "form-group" }/>
				</div>
				<div className="col-md-6 arabic-field">
					<TextInputField
						id={ "ArabicName" }
						holder={ this }
						required={ true }
						label={ Strings.name_arabic }
						type={ "arabic" }
						error={ error.ArabicName }
						disabled={ role.RoleOrder === 1 }/>
				</div>
			</div>
			<div className="modal-footer justify-content-start">
				<button
					type="button" className="btn btn_1"
					onClick={ this.onSubmit }>{ Strings.submit_label }</button>
				<button type="button" className="btn btn-link" onClick={ this.onReset }>{ Strings.reset }</button>
			</div>
		</Popup>;
	}

	private onSubmit = () => {
		if ( this.isValid() ) {
			const state = this.state;
			const party: Party = {
				EnglishName: state.EnglishName,
				ArabicName: state.ArabicName,
				SharePerc: 100,
			};
			this.dismissModel( party );
		}
	};

	private onReset = () => {
		this.setState( {
			...stateFromProps( this.props ) as State
		} );
	};

	private isValid() {
		let { EnglishName, ArabicName } = this.state;
		const error: { [ k: string ]: string } = {};
		let isValid = true;
		if ( StringUtil.isEmptyStringOrNull( EnglishName ) ) {
			error.EnglishName = Strings.required;
			isValid = false;
		}
		if ( StringUtil.isEmptyStringOrNull( ArabicName ) ) {
			error.ArabicName = Strings.required;
			isValid = false;
		}
		this.setState( {
			error: error,
		} );
		return isValid;
	}

	private dismissModel( party?: Party ) {
		JQModal( "AddPartyOnlyNamePopup" ).hide();
		const { role, editIndex } = this.state;
		if ( party ) {
			if ( editIndex !== undefined ) {
				role.Parties[ editIndex ] = party;
			} else {
				role.Parties.push( party );
			}
			if ( this.props.onDismiss )
				this.props.onDismiss( role );
		} else {
			if ( this.props.onDismiss )
				this.props.onDismiss( undefined );
		}
	}
}

function stateFromProps( props: Props ) {
	const role: Role = props.role;
	const editIndex = ( props.editIndex !== undefined ) ? props.editIndex : undefined;
	const parties: Party[] = ( role && role.Parties && role.Parties.length > 0 ) ? role.Parties : [];
	const party = ( editIndex !== undefined && parties && parties.length > 0 ) ? parties[ editIndex ] : undefined;
	const result: Partial<State> = {
		role: role,
		editIndex: editIndex,
		EnglishName: party ? party.EnglishName : "",
		ArabicName: party ? party.ArabicName : "",
		error: {},
	};
	return result;
}

export default AddPartyOnlyNamePopup;
